<script>
	import ComponentImage from '$lib/components/ComponentImage.svelte';
	import CTAButton from '$lib/components/CTAButton.svelte';
	import { GiveawayService } from '$lib/services/giveaway';

	/** @type {import('../__config/default.js').FamilyVacation2026Config['heroCallToAction']} */
	export let heroCallToAction;
</script>

<!-- Layout matches _home Sweepstakes.svelte column; type/sizes from hero-spec.md (px÷10→rem). -->
<div
	class="relative z-0 mx-auto my-[2rem] w-full min-w-0 text-center text-grey-400 sm:w-[55rem] md:mx-0 md:my-[4rem] md:w-[55rem] lg:ml-[7.5rem] lg:w-[60rem]"
>
	<div class="relative z-0 mt-[1.9rem] sm:mt-[2.6rem] md:mt-[15rem] lg:mt-[14.9rem]">
		<ComponentImage
			sources={heroCallToAction.abcmouseLogoSweepstakes.sources}
			imgConfig={{
				alt: heroCallToAction.abcmouseLogoSweepstakes.alt,
				class:
					'relative z-0 mx-auto block h-[9rem] w-[28.2rem] object-contain object-center sm:h-[11.7rem] sm:w-[36.8rem] md:h-[15.6rem] md:w-[49rem] lg:h-[15.6rem] lg:w-[49rem]',
			}}
		/>
	</div>

	<h1 class="hidden">
		{@html heroCallToAction.title}
	</h1>
	<h2
		class="relative z-10 mt-[-0.2rem] whitespace-nowrap font-abcmouse-sans text-[1.7rem] font-bold leading-[1.2] tracking-normal sm:mt-[-0.1rem] sm:text-[2.8rem] md:mt-[0.5rem] md:text-[2.8rem] lg:mt-[0.5rem] lg:text-[2.8rem]"
	>
		{@html heroCallToAction.subtitle}
	</h2>

	<div
		class="relative z-20 mt-[1rem] flex w-full min-w-0 flex-col items-center sm:mt-[1.5rem] md:mt-[2.6rem] lg:mt-[2.6rem]"
	>
		<CTAButton
			id="sweepstakes-learn-more-button"
			trackId={heroCallToAction.ctaButtonTrackId}
			btnClasses="!rounded-[2rem] before:rounded-[2rem]"
			text={heroCallToAction.ctaButtonText}
			textClasses="!text-[2.4rem] !font-bold md:!text-[2.8rem] lg:!text-[2.8rem]"
			containerClasses="!max-w-[25.1rem] !h-[5.2rem] mx-auto w-full min-w-0 md:!max-w-[30.2rem] md:!h-[6.4rem]"
			onClick={async () => {
				await GiveawayService.signUpCallback();
			}}
		/>
	</div>

	<p
		class="relative z-20 mt-[0.6rem] text-[1.3rem] font-bold leading-[1.6rem] tracking-normal sm:mt-[0.6rem] sm:text-[1.7rem] sm:leading-[2rem] md:mt-[1.2rem] md:text-[2rem] md:leading-[2.4rem] lg:mt-[1.2rem] lg:text-[2rem] lg:leading-[2.4rem]"
	>
		{@html heroCallToAction.subtext}
	</p>
</div>
